
function checkIfContrassegnoIsPresent(){
  let products_url = $('.cart__row .list-view-item__title a');
  for(i=0; i<products_url.length; i++ ){
    if(products_url[i].href.indexOf('contrassegno') != -1){
      return true;
    }
  }
  return false;
}

function setContrassegno(){
  let is_contrassegno_present = checkIfContrassegnoIsPresent();
  if(is_contrassegno_present){
    let variant_id = $('.cart__row .list-view-item__title a').attr('href').split('variant=')[1];
    jQuery.post('/cart/update.js', 'updates[' + variant_id + ']=0')
    .always(function(data) {
      console.log(data);
      if(data){
        location.reload();
      }
    });
  }
}



function cartInit(){
  setContrassegno();
}cartInit();

function getCookie(name) {
  var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
  return v ? v[2] : null;
}
function setCookie(name, value, days) {
  var d = new Date;
  d.setTime(d.getTime() + 24*60*60*1000*days);
  document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
}
function deleteCookie(name) { setCookie(name, '', -1); }



function CookiesModal() {
  function onLoad() {
    var elements = document.querySelectorAll('[data-module-cookies-modal]');
    elements.forEach(function(element) {
      var options = element.getAttribute('data-module-cookies-modal');
          options = JSON.parse(options || '{}');
  
      _CookiesModal(element, options);
    });
  };
  function _CookiesModal(element, options) {
    var defaults = {};

    options = Object.assign({}, defaults, options);

    var refs = {
      self: [element],
      cta:  element.querySelectorAll('[data-ref-cta]'),
      close:  element.querySelectorAll('[data-ref-close]')
    };

    var module = {
      element: element,
      options: options,
      refs: refs
    };

    refs.self.forEach(function(element) {
      var options = module.options;

      _Self(element, options, module);
    });

    refs.cta.forEach(function(element) {
      var options = element.getAttribute('data-ref-cta');
          options = JSON.parse(options || '{}');

      _Cta(element, options, module);
    });

    refs.close.forEach(function(element) {
      var options = element.getAttribute('data-ref-close');
          options = JSON.parse(options || '{}');

      _Close(element, options, module);
    });
  };
  function _Self(element, options, module) {
    if( !getCookie('cookiesmodal') ) {
      show();
    } else {
      set_rakuten_consent();
    }

    document.addEventListener('cookiesmodalcta:click', function() {
        hide();
        setCookie('cookiesmodal', true);
        set_rakuten_consent();
      });
    document.addEventListener('cookiesmodalclose:click', hide);

    function show() {
      document.documentElement.classList.add('is-active-cookies-modal');
    };

    function hide() {
      document.documentElement.classList.remove('is-active-cookies-modal');
    };

    function set_rakuten_consent() {
      window.__rmcp2 = [1,2,3,4,5,6,7,8,9,10];
      window.__rmuspc = 'YN';
    };
  };
  const _Cta = function(element, options, module) {
    element.addEventListener('click', function() {
      document.dispatchEvent(new Event('cookiesmodalcta:click'));
    });
  };
  const _Close =  function(element, options, module) {
    element.addEventListener('click', function() {
      document.dispatchEvent(new Event('cookiesmodalclose:click'));
    });
  };
  onLoad();
};

document.addEventListener('DOMContentLoaded', CookiesModal);
document.addEventListener('shopify:section:load', CookiesModal);
document.addEventListener('shopify:section:load', updatePromoBar);
window.addEventListener('resize', updatePromoBar);
function updatePromoBar() {
  try {
    if(window.innerWidth < 1025) {
      $('.promotional-banner').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        autoplay: true,
        arrows: false,
      });
    } else {
      if($('.promotional-banner').hasClass('slick-initialized')) {
        $('.promotional-banner').slick('unslick');
      }
    }
  } catch(e) {
    console.error(e);
  }
}
$(function() {
  updatePromoBar();
});

window.Shopify = window.Shopify || {};
  window.Shopify.theme = window.Shopify.theme || {};
  window.Shopify.theme.sections = window.Shopify.theme.sections || {};

  window.Shopify.theme.sections.registered = window.Shopify.theme.sections.registered || {};
  window.Shopify.theme.sections.instances = window.Shopify.theme.sections.instances || [];
  const registered = window.Shopify.theme.sections.registered;
  const instances = window.Shopify.theme.sections.instances;

  const selectors$6 = {
    id: 'data-section-id',
    type: 'data-section-type',
  };

  class Registration {
    constructor(type = null, components = []) {
      this.type = type;
      this.components = validateComponentsArray(components);
      this.callStack = {
        onLoad: [],
        onUnload: [],
        onSelect: [],
        onDeselect: [],
        onBlockSelect: [],
        onBlockDeselect: [],
        onReorder: [],
      };
      components.forEach((comp) => {
        for (const [key, value] of Object.entries(comp)) {
          const arr = this.callStack[key];
          if (Array.isArray(arr) && typeof value === 'function') {
            arr.push(value);
          } else {
            console.warn(`Unregisted function: '${key}' in component: '${this.type}'`);
            console.warn(value);
          }
        }
      });
    }

    getStack() {
      return this.callStack;
    }
  }

  class Section {
    constructor(container, registration) {
      this.container = validateContainerElement(container);
      this.id = container.getAttribute(selectors$6.id);
      this.type = registration.type;
      this.callStack = registration.getStack();

      try {
        this.onLoad();
      } catch (e) {
        console.warn(`Error in section: ${this.id}`);
        console.warn(this);
        console.warn(e);
      }
    }

    callFunctions(key, e = null) {
      this.callStack[key].forEach((func) => {
        const props = {
          id: this.id,
          type: this.type,
          container: this.container,
        };
        if (e) {
          func.call(props, e);
        } else {
          func.call(props);
        }
      });
    }

    onLoad() {
      this.callFunctions('onLoad');
    }

    onUnload() {
      this.callFunctions('onUnload');
    }

    onSelect(e) {
      this.callFunctions('onSelect', e);
    }

    onDeselect(e) {
      this.callFunctions('onDeselect', e);
    }

    onBlockSelect(e) {
      this.callFunctions('onBlockSelect', e);
    }

    onBlockDeselect(e) {
      this.callFunctions('onBlockDeselect', e);
    }

    onReorder(e) {
      this.callFunctions('onReorder', e);
    }
  }

  function validateContainerElement(container) {
    if (!(container instanceof Element)) {
      throw new TypeError('Theme Sections: Attempted to load section. The section container provided is not a DOM element.');
    }
    if (container.getAttribute(selectors$6.id) === null) {
      throw new Error('Theme Sections: The section container provided does not have an id assigned to the ' + selectors$6.id + ' attribute.');
    }

    return container;
  }

  function validateComponentsArray(value) {
    if ((typeof value !== 'undefined' && typeof value !== 'object') || value === null) {
      throw new TypeError('Theme Sections: The components object provided is not a valid');
    }

    return value;
  }

  function debounce(fn, time) {
    let timeout;
    return function () {
      // eslint-disable-next-line prefer-rest-params
      if (fn) {
        const functionCall = () => fn.apply(this, arguments);
        clearTimeout(timeout);
        timeout = setTimeout(functionCall, time);
      }
    };
  }

 /*
   * @shopify/theme-sections
   * -----------------------------------------------------------------------------
   *
   * A framework to provide structure to your Shopify sections and a load and unload
   * lifecycle. The lifecycle is automatically connected to theme editor events so
   * that your sections load and unload as the editor changes the content and
   * settings of your sections.
   */

 function register(type, components) {
  if (typeof type !== 'string') {
    throw new TypeError('Theme Sections: The first argument for .register must be a string that specifies the type of the section being registered');
  }

  if (typeof registered[type] !== 'undefined') {
    throw new Error('Theme Sections: A section of type "' + type + '" has already been registered. You cannot register the same section type twice');
  }

  if (!Array.isArray(components)) {
    components = [components];
  }

  const section = new Registration(type, components);
  registered[type] = section;

  return registered;
}

function load(types, containers) {
  types = normalizeType(types);

  if (typeof containers === 'undefined') {
    containers = document.querySelectorAll('[' + selectors$6.type + ']');
  }

  containers = normalizeContainers(containers);

  types.forEach(function (type) {
    const registration = registered[type];

    if (typeof registration === 'undefined') {
      return;
    }

    containers = containers.filter(function (container) {
      // Filter from list of containers because container already has an instance loaded
      if (isInstance(container)) {
        return false;
      }

      // Filter from list of containers because container doesn't have data-section-type attribute
      if (container.getAttribute(selectors$6.type) === null) {
        return false;
      }

      // Keep in list of containers because current type doesn't match
      if (container.getAttribute(selectors$6.type) !== type) {
        return true;
      }

      instances.push(new Section(container, registration));

      // Filter from list of containers because container now has an instance loaded
      return false;
    });
  });
}

function reorder(selector) {
  var instancesToReorder = getInstances(selector);

  instancesToReorder.forEach(function (instance) {
    instance.onReorder();
  });
}

function unload(selector) {
  var instancesToUnload = getInstances(selector);

  instancesToUnload.forEach(function (instance) {
    var index = instances
      .map(function (e) {
        return e.id;
      })
      .indexOf(instance.id);
    instances.splice(index, 1);
    instance.onUnload();
  });
}

function getInstances(selector) {
  var filteredInstances = [];

  // Fetch first element if its an array
  if (NodeList.prototype.isPrototypeOf(selector) || Array.isArray(selector)) {
    var firstElement = selector[0];
  }

  // If selector element is DOM element
  if (selector instanceof Element || firstElement instanceof Element) {
    var containers = normalizeContainers(selector);

    containers.forEach(function (container) {
      filteredInstances = filteredInstances.concat(
        instances.filter(function (instance) {
          return instance.container === container;
        })
      );
    });

    // If select is type string
  } else if (typeof selector === 'string' || typeof firstElement === 'string') {
    var types = normalizeType(selector);

    types.forEach(function (type) {
      filteredInstances = filteredInstances.concat(
        instances.filter(function (instance) {
          return instance.type === type;
        })
      );
    });
  }

  return filteredInstances;
}

function getInstanceById(id) {
  var instance;

  for (var i = 0; i < instances.length; i++) {
    if (instances[i].id === id) {
      instance = instances[i];
      break;
    }
  }
  return instance;
}

function isInstance(selector) {
  return getInstances(selector).length > 0;
}

function normalizeType(types) {
  // If '*' then fetch all registered section types
  if (types === '*') {
    types = Object.keys(registered);

    // If a single section type string is passed, put it in an array
  } else if (typeof types === 'string') {
    types = [types];

    // If single section constructor is passed, transform to array with section
    // type string
  } else if (types.constructor === Section) {
    types = [types.prototype.type];

    // If array of typed section constructors is passed, transform the array to
    // type strings
  } else if (Array.isArray(types) && types[0].constructor === Section) {
    types = types.map(function (Section) {
      return Section.type;
    });
  }

  types = types.map(function (type) {
    return type.toLowerCase();
  });

  return types;
}

function normalizeContainers(containers) {
  // Nodelist with entries
  if (NodeList.prototype.isPrototypeOf(containers) && containers.length > 0) {
    containers = Array.prototype.slice.call(containers);

    // Empty Nodelist
  } else if (NodeList.prototype.isPrototypeOf(containers) && containers.length === 0) {
    containers = [];

    // Handle null (document.querySelector() returns null with no match)
  } else if (containers === null) {
    containers = [];

    // Single DOM element
  } else if (!Array.isArray(containers) && containers instanceof Element) {
    containers = [containers];
  }

  return containers;
}

const selectors$l = {
  frame: '[data-ticker-frame]',
  scale: '[data-ticker-scale]',
  text: '[data-ticker-text]',
  clone: 'data-clone',
};

const attributes$3 = {
  speed: 'data-marquee-speed',
};

const classes$a = {
  animation: 'ticker--animated',
  unloaded: 'ticker--unloaded',
  comparitor: 'ticker__comparitor',
};

const settings$2 = {
  textAnimationTime: 1.63, // 100px going to move for 1.63s
  space: 100, // 100px
};

class Ticker {
  constructor(el, stopClone = false) {
    this.frame = el;
    this.stopClone = stopClone;
    this.scale = this.frame.querySelector(selectors$l.scale);
    this.text = this.frame.querySelector(selectors$l.text);

    this.comparitor = this.text.cloneNode(true);
    this.comparitor.classList.add(classes$a.comparitor);
    this.frame.appendChild(this.comparitor);
    this.scale.classList.remove(classes$a.unloaded);
    this.resizeEvent = debounce(() => this.checkWidth(), 100);
    this.listen();
  }

  unload() {
    document.removeEventListener('theme:resize', this.resizeEvent);
  }

  listen() {
    document.addEventListener('theme:resize', this.resizeEvent);
    this.checkWidth();
  }

  checkWidth() {
    const padding = window.getComputedStyle(this.frame).paddingLeft.replace('px', '') * 2;
    const speed = this.frame.getAttribute(attributes$3.speed) ? this.frame.getAttribute(attributes$3.speed) : settings$2.textAnimationTime;

    if (this.frame.clientWidth - padding < this.comparitor.clientWidth || this.stopClone) {
      this.text.classList.add(classes$a.animation);
      if (this.scale.childElementCount === 1) {
        this.clone = this.text.cloneNode(true);
        this.clone.setAttribute(selectors$l.clone, '');
        this.scale.appendChild(this.clone);

        if (this.stopClone) {
          for (let index = 0; index < 10; index++) {
            const cloneSecond = this.text.cloneNode(true);
            cloneSecond.setAttribute(selectors$l.clone, '');
            this.scale.appendChild(cloneSecond);
          }
        }

        const animationTimeFrame = ((this.text.clientWidth / settings$2.space) * Number(speed)).toFixed(2);

        this.scale.style.setProperty('--animation-time', `${animationTimeFrame}s`);
      }
    } else {
      this.text.classList.add(classes$a.animation);
      let clone = this.scale.querySelector(`[${selectors$l.clone}]`);
      if (clone) {
        this.scale.removeChild(clone);
      }
      this.text.classList.remove(classes$a.animation);
    }
  }
}

const selectors$m = {
  bar: '[data-bar]',
  barSlide: '[data-slide]',
  frame: '[data-ticker-frame]',
  header: '[data-header-wrapper]',
  slider: '[data-slider]',
  slideValue: 'data-slide',
  tickerScale: '[data-ticker-scale]',
  tickerText: '[data-ticker-text]',
  dataTargetReferrer: 'data-target-referrer',
};

const sections$9 = {};

class Bar {
  constructor(holder, elem) {
    this.barHolder = holder;
    this.elem = elem;
    this.locationPath = location.href;

    this.slides = this.barHolder.querySelectorAll(selectors$m.barSlide);
    this.slider = this.barHolder.querySelector(selectors$m.slider);

    this.init();
  }

  init() {
    this.removeAnnouncement();

    if (this.slider) {
      this.initSliders();
    }

    if (!this.slider) {
      this.initTickers(true);
    }
  }

  /**
   * Delete announcement which has a target referrer attribute and it is not contained in page URL
   */
  removeAnnouncement() {
    for (let index = 0; index < this.slides.length; index++) {
      const element = this.slides[index];

      if (!element.hasAttribute(selectors$m.dataTargetReferrer)) {
        continue;
      }

      if (this.locationPath.indexOf(element.getAttribute(selectors$m.dataTargetReferrer)) === -1 && !window.Shopify.designMode) {
        element.parentNode.removeChild(element);
      }
    }
  }

  /**
   * Init slider
   */
  initSliders() {
    $(this.elem).slick({
      dots: false,
      autoplay: true,
      arrows: false
    });
    this.initTickers();
  }

  /**
   * Init tickers in sliders
   */
  initTickers(stopClone = false) {
    const frames = this.barHolder.querySelectorAll(selectors$m.frame);

    frames.forEach((element) => {
      new Ticker(element, stopClone);
    });
  }

  toggleTicker(e, isStoped) {
    const tickerScale = document.querySelector(selectors$m.tickerScale);
    const element = document.querySelector(`[${selectors$m.slideValue}="${e.detail.blockId}"]`);
    debugger
    if (isStoped && element) {
      tickerScale.setAttribute('data-stop', '');
      tickerScale.querySelectorAll(selectors$m.tickerText).forEach((textHolder) => {
        textHolder.classList.remove('ticker--animated');
        textHolder.style.transform = `translate3d(${-(element.offsetLeft - element.clientWidth)}px, 0, 0)`;
      });
    }

    if (!isStoped && element) {
      tickerScale.querySelectorAll(selectors$m.tickerText).forEach((textHolder) => {
        textHolder.classList.add('ticker--animated');
        textHolder.removeAttribute('style');
      });
      tickerScale.removeAttribute('data-stop');
    }
  }

  onBlockSelect(e) {
    if (this.slider) {
      this.slider.onBlockSelect(e);
    } else {
      this.toggleTicker(e, true);
    }
  }

  onBlockDeselect(e) {
    if (this.slider) {
      this.slider.onBlockDeselect(e);
    } else {
      this.toggleTicker(e, false);
    }
  }
}

const bar = {
  onLoad() {
    sections$9[this.id] = [];
    const element = this.container.querySelector(selectors$m.bar);
    if (element) {
      sections$9[this.id].push(new Bar(element, selectors$m.slider));
    }
  },
  onBlockSelect(e) {
    if (sections$9[this.id].length) {
      sections$9[this.id].forEach((el) => {
        if (typeof el.onBlockSelect === 'function') {
          el.onBlockSelect(e);
        }
      });
    }
  },
  onBlockDeselect(e) {
    if (sections$9[this.id].length) {
      sections$9[this.id].forEach((el) => {
        if (typeof el.onBlockSelect === 'function') {
          el.onBlockDeselect(e);
        }
      });
    }
  },
};

register('announcement', [bar]);

document.addEventListener('DOMContentLoaded', function () {
  // Load all registered sections on the page.
  load('*');
});

var instagramLoaded = false;

const OBSERVER = new IntersectionObserver((entries) => {
  if(entries[0].intersectionRatio <= 0) return;

  console.log('in sight', entries[0]);
  if(!instagramLoaded) {
    const scriptElem = document.createElement('script');
    scriptElem.src = 'https://showcase.abovemarket.com/embed/gallery/19598';
    scriptElem.dataset['galleryId'] = '19598';
    entries[0].target.appendChild(scriptElem); 
    instagramLoaded = true;
  }
}, {
  rootMargin: '100px',
  thresholds: 0.1
})

document.addEventListener('DOMContentLoaded', () => {
  const instagramSection = document.querySelector('.instagram-feed-embed');
  if(instagramSection) {
    OBSERVER.observe(instagramSection);
  }
});

$('.product-single__thumbnail--product-template').on('click', function (e) {
  e.preventDefault();
});


